const COMMENTS_DEFAULT_COUNT = 3

function addCreatedComment(state, comment) {
  state.comments.unshift(comment)
  if (state.comments.length > COMMENTS_DEFAULT_COUNT) {
    // We remove the last shown comment, since it's moved to the next page.
    state.comments.pop()
  }
}

function appendComments(state, { comments, currentPage, nextPage }) {
  state.comments = state.comments.concat(comments)
  setPagination(state, { currentPage, nextPage })
}

function initializeComments(state, { comments, currentPage, nextPage }) {
  state.comments = comments
  setPagination(state, { currentPage, nextPage} )
}

function setErrorLoadingComments(state, error) {
  state.errorLoadingComments = error
}

function setPagination(state, { currentPage, nextPage }) {
  state.currentPage = currentPage
  state.nextPage = nextPage
}

function setPetitionSlug(state, petitionSlug) {
  state.petitionSlug = petitionSlug
}

export default {
  addCreatedComment,
  appendComments,
  initializeComments,
  setErrorLoadingComments,
  setPagination,
  setPetitionSlug
}
